import React from "react";

export const overviewFaq = [
  {
    title: "Buy & Sell Private Shares with Other Investors",
    description: (
      <p className="ml-8">
        The BnkToTheFuture Secondary Market gives verified investors the ability
        to trade private equity shares securely. Buyers and sellers set their
        own pricing, enabling peer-to-peer trading opportunities beyond the
        original funding round.
      </p>
    ),
  },
  {
    title: "How it works",
    description: (
      <ol className="list-decimal pl-4 space-y-1 ml-8">
        <li>
          <strong>Verify & Certify</strong> – Complete your investor
          verification.
        </li>
        <li>
          <strong>Place an Order</strong> – Choose an existing offer or create
          your own buy/sell order with a custom price.
        </li>
        <li>
          <strong>Pre-Sign Agreement</strong> – Review and pre-sign a legally
          binding contract for execution once matched.
        </li>
        <li>
          <strong>Settlement & Share Transfer</strong> – Once matched, payment
          is processed and your portfolio is automatically updated.
        </li>
      </ol>
    ),
  },
  {
    title: "Why Use the Secondary Market?",
    description: (
      <div className="space-y-2 ml-8">
        <div>
          <p>
            <strong>Buyers:</strong> Access opportunities in companies no longer
            accepting new funding, increase your stake, or find discounted deals
            from early investors.
          </p>
        </div>
        <div>
          <p>
            <strong>Sellers:</strong> Exit positions before a potential IPO or
            acquisition, rebalance your portfolio, and access early liquidity.
          </p>
        </div>
      </div>
    ),
  },
];

export const tradingFaq = [
  {
    title: "How does trading work?",
    description: (
      <>
        <p className="ml-8">
          The Secondary Market functions as a private bulletin board, where
          investors manually match buy and sell orders. It operates similarly to
          an Over-the-Counter (OTC) market.
        </p>

        <p className="ml-8">
          Please note: Due to limited liquidity and deal flow, trades may take
          longer to match than on a traditional exchange.
        </p>
      </>
    ),
  },
  {
    title: "What is the minimum order amount?",
    description: (
      <p className="ml-8">
        The minimum trade size is <strong>$10 USD.</strong>
      </p>
    ),
  },
  {
    title: "How do I start investing?",
    description: (
      <>
        <p className="ml-8">To begin:</p>
        <ol>
          <li>Complete your investor verification (Tier 3 or higher).</li>
          <li>Fund your account with USDT (Tether).</li>
          <li>Browse available listings.</li>
          <li>Create a buy order with a set price.</li>
        </ol>
      </>
    ),
  },
  {
    title: "What are the fees?",
    description: (
      <>
        <p className="ml-8">
          A 2.5% trade fee is charged on successfully completed transactions.
          This covers share transfers, contract processing, and escrow services.
        </p>

        <p className="ml-8">No fees apply to unfilled or cancelled orders.</p>
      </>
    ),
  },
  {
    title: "Why are my funds blocked when I place an order?",
    description: (
      <>
        <p className="ml-8">
          To prevent double-spending, funds are held in escrow when an order is
          placed.
        </p>

        <p className="ml-8">
          If the order is not matched, your funds are released and available to
          withdraw or use for other investments.
        </p>
      </>
    ),
  },
];
